import { Injectable, inject } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable, map } from 'rxjs';
import { feedbackEligibleQuery, saveFeedbackMutation } from './feedback.queries';
import { IResidentFeedbackInput } from '@resident-nx/web/feedback/model';

@Injectable({ providedIn: 'root' })
export class FeedbackFacade {
  readonly #apollo = inject(Apollo);

  public isEligible(): Observable<boolean> {
    return this.#apollo
      .query<{ feedbackEligible: boolean }>({
        query: feedbackEligibleQuery,
        errorPolicy: 'all',
      })
      .pipe(map(response => response?.data?.feedbackEligible ?? false));
  }

  public saveFeedback(input: IResidentFeedbackInput): Observable<boolean> {
    return this.#apollo
      .mutate<{ saveFeedback: boolean }>({
        mutation: saveFeedbackMutation,
        variables: { input },
      })
      .pipe(map(response => response?.data?.saveFeedback ?? false));
  }
}
